import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import {HashRouter as Router} from 'react-router-dom';
import registerServiceWorker from './registerServiceWorker';
import "./style.sass";
import "element-theme-default";
import locale from "element-react/src/locale/lang/en";
import { i18n } from 'element-react'
i18n.use(locale);

const app = <Router>
    <App/>
</Router>

ReactDOM.render(app, document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js